import { render, staticRenderFns } from "./SimplePersonIcon.vue?vue&type=template&id=d2e21a76"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2e21a76')) {
      api.createRecord('d2e21a76', component.options)
    } else {
      api.reload('d2e21a76', component.options)
    }
    module.hot.accept("./SimplePersonIcon.vue?vue&type=template&id=d2e21a76", function () {
      api.rerender('d2e21a76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/SimplePersonIcon.vue"
export default component.exports